/** Shared auction-countdown urgency display logic, used by PropertyCard, PropertyCtaPanel and BidForm. */

import { formatCountdown } from '@federa/utils/dates/format-countdown';
import { AUCTION_URGENCY_THRESHOLD_SECONDS } from '@federa/const/messaging';
import { COUNTDOWN_LABEL_AUCTION_CLOSED } from '@federa/const/countdown-label-values';
import { MISSING_VALUE_PLACEHOLDER } from '@federa/const/sentinels';
import { colors } from '../css-refs.colors.ts';

interface CountdownDisplayInfo {
	showCountdown: boolean;
	countdownColor: string;
	countdownLabel: string;
	isUrgent: boolean;
}

/** Countdown display info from remaining seconds: urgency color (error for urgent, success otherwise), formatted label, and whether to show the countdown at all. */
export function getCountdownDisplay(remainingSeconds: number | null): CountdownDisplayInfo {
	if (remainingSeconds === null) {
		return {
			showCountdown: false,
			countdownColor: colors.text.primary,
			countdownLabel: MISSING_VALUE_PLACEHOLDER,
			isUrgent: false,
		};
	}

	if (remainingSeconds <= 0) {
		return {
			showCountdown: false,
			countdownColor: colors.text.secondary,
			countdownLabel: COUNTDOWN_LABEL_AUCTION_CLOSED,
			isUrgent: false,
		};
	}

	const isUrgent = remainingSeconds < AUCTION_URGENCY_THRESHOLD_SECONDS;
	const countdownColor = isUrgent ? colors.semantic.error : colors.semantic.success;
	const countdownLabel = formatCountdown(remainingSeconds);

	return {
		showCountdown: true,
		countdownColor,
		countdownLabel,
		isUrgent,
	};
}
